import { Box, Chip, Divider, IconButton, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import React from 'react';
import { Eye } from 'untitledui-js-base';
import { AccidentTags } from '../accidents/AccidentMerchantItem';
import { RegistryAccidentResponseItem } from './type';

interface DialogAccidentListProps {
  accidents: RegistryAccidentResponseItem[];
  onClick?: (id: number) => void;
}
export const DialogAccidentList = ({ accidents, onClick }: DialogAccidentListProps) => (
  <Stack
    mt={3}
    p={1}
    sx={{
      maxHeight: { xs: '200px', md: '300px' },
      overflowY: 'auto',
      border: '1px solid',
      borderColor: 'grey.300',
      '&::-webkit-scrollbar': { width: '8px' },
      '&::-webkit-scrollbar-track': { backgroundColor: 'grey.100' },
      '&::-webkit-scrollbar-thumb': { backgroundColor: 'error.main', borderRadius: '4px' }
    }}
  >
    <Typography fontWeight="700" px={1}>
      Přiřazené nehody:
    </Typography>
    <List sx={{ width: 1 }}>
      {accidents.map((accident, idx) => {
        const commissionValue = accident?.commission?.value;
        const commissionPercentage = accident?.commission?.percentage;
        const isPaid = Boolean(accident?.commission?.date);

        return (
          <React.Fragment key={accident.id}>
            <ListItem
              secondaryAction={
                <IconButton
                  size="small"
                  aria-label="edit"
                  color="info"
                  onClick={() => onClick?.(accident.id)}
                  sx={{ top: '-30px' }}
                >
                  <Eye />
                </IconButton>
              }
              alignItems="flex-start"
              sx={{ paddingX: 1, paddingY: 1, width: 1 }}
            >
              <ListItemText
                primary={
                  <Typography fontWeight="600">
                    {accident.user
                      ? [
                          [accident.user.degree, accident.user.name, accident.user.surname].filter(Boolean).join(' '),
                          accident.user.company?.companyName
                        ]
                          .filter(Boolean)
                          .join(' - ')
                      : ''}
                  </Typography>
                }
                secondary={
                  <Stack spacing={1} mt={1} component="span">
                    {isPaid && (
                      <Box>
                        <Chip size="small" label="Provize vyplacena" variant="filled" color="success" />
                      </Box>
                    )}
                    {accident.car && (
                      <Typography variant="body3">
                        {[accident.car?.brand, accident.car?.model, accident.car.plateNumber].filter(Boolean).join(' ')}
                      </Typography>
                    )}
                    <Typography variant="body3">{`${accident.date} | ${accident.contractNumber}`}</Typography>
                    <Typography variant="body3">
                      {`Celková výše provize: ${commissionValue}`}
                      {Boolean(commissionPercentage) && ` (${commissionPercentage} %)`}
                    </Typography>

                    <Typography variant="body3" sx={{ color: isPaid ? 'success.main' : 'error.main' }}>
                      {`Vyplacená provize: ${isPaid ? accident?.commission?.date : 'NE'}`}
                    </Typography>
                    <AccidentTags accident={accident} />
                  </Stack>
                }
              />
            </ListItem>
            {idx < accidents?.length - 1 && <Divider />}
          </React.Fragment>
        );
      })}
    </List>
  </Stack>
);
